import { render, staticRenderFns } from "./ContentSection.vue?vue&type=template&id=5506cd40"
import script from "./ContentSection.vue?vue&type=script&lang=js"
export * from "./ContentSection.vue?vue&type=script&lang=js"
import style0 from "./ContentSection.vue?vue&type=style&index=0&id=5506cd40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports